import React, {useState, useEffect, useContext } from 'react';
import axios from '../Common/axios';
import {Button, Input, Modal, Select, Table, DatePicker, Typography} from "antd";
import CodeSelect from '../Common/CodeSelect';
import {getGridTableHeight, getPopupSizeOption, dateFormatter} from '../Common/util';
import {getFindAnalysisList} from '../Common/api';
import {excelDownload} from '../Common/function';
import AnalysisCreate from './AnalysisCreate.js';
import AnalysisInfo from '../AnalysisInfo/AnalysisInfo.js';
import AnalysisResult from './AnalysisResult.js';
import AppContext from '../../components/AppContext';
import Cookies from 'js-cookie';
import TopMenu from '../Common/TopMenu';
import {getCodeName} from '../Common/CodeSelect';
import { getCodeList } from '../Common/codeManager';

const {Option} = Select;
const { RangePicker } = DatePicker;

/** -------------------------------------------------------------------------- **/
const AnalysisList = () => {
    const myContext = useContext(AppContext);
    //console.log(myContext);

    // 쿠키에서 인증 토큰 값 가져오기
    const authToken = Cookies.get('access_token');
    // 인증 토큰 값이 존재하면 로그인된 상태로 처리
    const authenticated = authToken?true:false;

    // 변수 선언
    const [companyCode, setCompanyCode] = useState(myContext.companyCode);
    const [companyName, setCompanyName] = useState(myContext.companyName);
    const [assetType, setAssetType] = useState(myContext.assetType);
    const [assetTypeName, setAssetTypeName] = useState(myContext.assetTypeName);
    const [assetSpec, setAssetSpec] = useState(myContext.assetSpec);
    const [assetSpecName, setAssetSpecName] = useState(myContext.assetSpecName);
    const [reportName, setReportName] = useState('');
    const [startYmd, setStartYmd] = useState('');
    const [endYmd, setEndYmd] = useState('');

    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [isDataChange, setIsDataChange] = useState(false);
    const [isOpenCreate, setIsOpenCreate] = useState(false);
    const [isOpenInfo, setIsOpenInfo] = useState(false);
    const [isOpenResult, setIsOpenResult] = useState(false);

    const [isReportId, setIsReportId] = useState(false);
    const [isResultType, setIsResultType] = useState('');

    // 페이지 진입 시 코드 목록 갱신
    useEffect(() => {
        // 캐시된 코드 목록 갱신 (1분 캐시)
        getCodeList();
    }, []);
    
    // 회사코드 또는 자산유형 변경 시 자동 조회
    useEffect(() => {
        // 회사코드가 있을 때만 조회
        if (companyCode) {
            findAnalysisList();
        }
    }, [companyCode, assetType]);

    /** -------------------------------------------------------------------------- **/
    // 회사코드 변경
    const onChangeCompanyCode = (value, option) => {
        // const name = option.children.length > 1 ? option.children[2] : option.children;
        const name = option.children.props.children.length > 3 ? option.children.props.children[3] : option.children.props.children[2];
        setCompanyCode(value);
        // setCompanyName(option.children[2]);
        setCompanyName(name);
        myContext.setCompanyCode(value);
        // myContext.setCompanyName(option.children[2]);
        myContext.setCompanyName(name);
    };

    // 자산유형 변경
    const onChangeAssetType = (value, option) => {
        // const name = option.children.length > 1 ? option.children[2] : option.children;
        const name = option.children.props.children.length > 3 ? option.children.props.children[3] : option.children.props.children[2];
        setAssetType(value);
        // setAssetTypeName(option.children[2]);
        setAssetTypeName(name);
        myContext.setAssetType(value);
        // myContext.setAssetTypeName(option.children[2]);
        myContext.setAssetTypeName(name);
    };

    // 최초분석일자 변경
    const onChangeDateRange = (values, formatString) => {
        //console.log(formatString);
        if(formatString != null) {
            if( formatString.length >=1) {
                setStartYmd(formatString[0].replace(/[-]/g,''));
            }
            if( formatString.length >= 2) {
                setEndYmd(formatString[1].replace(/[-]/g,''));
            }
        }
    };

    // InputText 입력값 변경
    const onChangeInputHandler = (event) => {
        if (event.target.id == "reportName") {
            setReportName(event.target.value);
        } 
    };

    // 검색 클릭 시
    const onClickSearchHandler = () => {
        // 회사 필수조건 체크
        if (companyCode == '') {
            Modal.info({title: "회사는 필수 조회조건입니다."});
            return;
        }

        // 취약점분석 조회
        findAnalysisList();

    };

    // 취약점분석 조회 API
    const findAnalysisList = () => {
        // 회사코드가 없으면 조회하지 않음
        if (!companyCode) return;
        
        setIsLoading(true);
        setIsDataChange(false);
        axios.get(getFindAnalysisList(companyCode,assetType,reportName,startYmd,endYmd))
            .then((response) => {
                //console.log(response);
                setIsLoading(false);
                setDataSource(response.data);

                // response.data.map((item) => {
                //     // console.log("curl -X POST \"https://rms.isecurekr.com/delete/VaReport/\" -H \"Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzU4MTY5NjQ0LCJpYXQiOjE3NTgxNjI0MzEsImp0aSI6IjNmMmQxNGRhZWViYTQwY2U4NTEyOGM3YmFkODA1ZTJiIiwidXNlcl9pZCI6MX0.YZrlixEaTzRjT_E5QFfCTE-8lh3nH61E1BH54sJND8Y\" -H \"Content-Type: application/json\" -d '{\"reportId\":\"" + item.report_id+"\"}'");
                //     console.log(item.report_id);
                // });

                if(response.data.totalCount == 0) {
                    Modal.info({title: "No Data.", okText:"Close"});
                }
            })
            .catch((error) => {
                console.log("AnalysisList.js --- 113 error");
                console.dir(error);
                setIsLoading(false);
            });
    };

    // 취약점분석 등록 클릭 시
    const onClickCreateHandler = () => {
        
        // 회사 필수조건 체크
        if (companyCode == '') {
            Modal.info({title: "회사는 필수 조회조건입니다."});
            return;
        }
        
        const _width = '900';
        const _height = '400';
        const _left = Math.ceil(( window.screen.width - _width )/2);
        const _top = Math.ceil(( window.screen.height - _height )/2); 
        
        setIsDataChange(false);
        //window.open('#/analysis/create', 'analysisCreate', 'width='+ _width +', height='+ _height +', left=' + _left + ', top='+ _top + 'scrollbars=no');
        setIsOpenCreate(true);
    }
    
    // 화면로딩시 자동조회
    useEffect(() => {
        
        window.onHandleDataChange = () => {
            setIsDataChange(true);
        };

        if (companyCode != '') {
            findAnalysisList();
        }
    }, []);

    // 정보 변경시 재조회
    useEffect(() => {
        // 취약점분석 조회
        if(isDataChange && companyCode != '') {
            findAnalysisList();
        }
    }, [isDataChange]);

    /** -------------------------------------------------------------------------- **/
    function onClickDetailHandler(value) {

        var _width = '1400';
        var _height = '900';
        const option = getPopupSizeOption(_width, _height);

        if (value.columnType == 'info') {
            const url = '#/analysis/info/'+value.report_id;
            const target = 'analysisInfo';
            //window.open(url, target, option);
            setIsOpenInfo(true);
            setIsReportId(value.report_id);

        } else if (value.columnType == 'created_result' || value.columnType == 'updated_result') {
            // const resultType = value.columnType=='created_result'?'C':'U';
            // const url = '#/analysis/result/'+value.report_id+'/'+resultType;
            // const target = 'analysisResult';
            // //window.open(url, target, option);
            // setIsOpenResult(true);
            // setIsReportId(value.report_id);
            // setIsResultType(resultType);
            
            const resultType = value.columnType=='created_result'?'C':'U';
            const url = '#/analysis/resultpop/'+value.report_id+'/'+resultType;
            const target = 'analysisResult';
            const option_fix = getPopupSizeOption('1600', '1100', 'fix');
            window.open(url, target, option_fix);

        } else if (value.columnType == 'vulnerablity' || value.columnType == 'riskReport' || value.columnType == 'riskManagement' || value.columnType == 'implement') {
            const url = '#/report/'+value.columnType+'/'+value.report_id+(value.companyCode ? '?cd='+value.companyCode: '');
            const target = value.columnType;
            window.open(url, target, option);

        } else if (value.columnType == 'assetReport') {
            // const url = '#/report/'+value.columnType+'/'+value.report_id+'/'+value.asset_cd+'/'+value.com_cd+'/'+value.asset_type;
            // 상세진단결과 팝업창에 파라미터로 전달되는 경로패스 수정 
            // App.js 에서 {AssetReport}값이 있는 라우터 경로도 수정해줘야 한다. 
            const url = '#/report/'+value.columnType+'/'+value.report_id;
            const target = value.columnType;
            const option_fix = getPopupSizeOption('1500', '900', 'fix');
            window.open(url, target, option_fix);

        } else if (value.columnType == 'implementResult') {
            const url = '#/report/'+value.columnType+'/'+value.report_id;
            const target = value.columnType;
            const option_fix = getPopupSizeOption('1500', '900', 'fix');
            window.open(url, target, option_fix);

        } 

    };

    // 취약점분석_목록
    const analysisColumnData = [
        {
            title: '자산구분',
            dataIndex: 'asset_type',
            key: 'asset_type',
            width: '100px',
            align: 'center',
            fixed: true,
            sorter: {
                compare: (a, b) => a.asset_type.localeCompare(b.asset_type),
            },
            render: (_ , rowData ) => {
                return (
                    getCodeName('asset_type', rowData.asset_type)
                );
            },
        },
        {
            title: '취약점분석ID',
            dataIndex: 'report_id',
            key: 'report_id',
            width: '120px',
            align: 'center',
            fixed: true,
            sorter: {
                compare: (a, b) => a.report_id.localeCompare(b.report_id),
            },
        },
        {
            title: '취약점분석명',
            dataIndex: 'report_nm',
            key: 'report_nm',
            width: '250px',
            align: 'center',
            fixed: true,
            ellipsis : true,
            render: (_ , rowData ) => {
                return (
                    <Typography.Link onClick={() => onClickDetailHandler({columnType: 'info', report_id: rowData.report_id})}>
                        {rowData.report_nm}
                    </Typography.Link>
                );
            },
            sorter: {
                compare: (a, b) => a.report_nm.localeCompare(b.report_nm),
            },
        },
        {
            title: '확정여부',
            dataIndex: 'confirm',
            key: 'confirm',
            width: '70px',
            align: 'center',
            fixed: true,
            ellipsis : true,
            sorter: {
                compare: (a, b) => a.confirm.localeCompare(b.confirm),
            },
        },
        {
            title: '최초분석',
            dataIndex: 'created_ymd',
            key: 'created_ymd',
            width: '70px',
            align: 'center',
            render: (_ , rowData ) => {
                return (
                    <Typography.Link onClick={() => onClickDetailHandler({columnType: 'created_result', report_id: rowData.report_id})}>
                        {rowData.created_ymd&&rowData.created_ymd!='None'?dateFormatter(rowData.created_ymd):'Upload'}
                    </Typography.Link>
                );
            },
            className: 'sum_col'
        },
        {
            title: '취약점진단',
            dataIndex: 'vulnerablity',
            key: 'vulnerablity',
            width: '70px',
            align: 'center',
            render: (_ , rowData ) => {
                return (
                    <Typography.Link onClick={() => onClickDetailHandler({columnType: 'vulnerablity', report_id: rowData.report_id})}>
                        {rowData.created_ymd&&rowData.created_ymd!='None'?'Report':''}
                    </Typography.Link>
                );
            },
        },
        {
            title: '상세진단결과',
            dataIndex: 'assetReport',
            key: 'assetReport',
            width: '70px',
            align: 'center',
            render: (_ , rowData ) => {
                return (
                    <Typography.Link onClick={() => onClickDetailHandler({columnType: 'assetReport', report_id: rowData.report_id})}>
                        {rowData.created_ymd&&rowData.created_ymd!='None'?'Report':''}
                    </Typography.Link>
                );
            },
        },
        {
            title: '위험평가',
            dataIndex: 'riskReport',
            key: 'riskReport',
            width: '70px',
            align: 'center',
            render: (_ , rowData ) => {
                return (
                    <Typography.Link onClick={() => onClickDetailHandler({columnType: 'riskReport', report_id: rowData.report_id, companyCode: companyCode})}>
                        {rowData.created_ymd&&rowData.created_ymd!='None'?'Report':''}
                    </Typography.Link>
                );
            },
        },
        {
            title: '위험관리',
            dataIndex: 'riskManagement',
            key: 'riskManagement',
            width: '70px',
            align: 'center',
            render: (_ , rowData ) => {
                return (
                    <Typography.Link onClick={() => onClickDetailHandler({columnType: 'riskManagement', report_id: rowData.report_id})}>
                        {rowData.created_ymd&&rowData.created_ymd!='None'?'Report':''}
                    </Typography.Link>
                );
            },
        },
        {
            title: '이행점검',
            dataIndex: 'updated_ymd',
            key: 'updated_ymd',
            width: '70px',
            align: 'center',
            render: (_ , rowData ) => {
                return (
                    rowData.created_ymd && rowData.created_ymd!='None'?(
                    <Typography.Link onClick={() => onClickDetailHandler({columnType: 'updated_result', report_id: rowData.report_id})}>
                        {rowData.updated_ymd && rowData.updated_ymd!='None'?dateFormatter(rowData.updated_ymd):'Upload' }
                         {/* rowData.created_ymd && rowData.created_ymd!='None'?'Upload':'없음'} */}
                    </Typography.Link>):""
                );
            },
            className: 'sum_col'
        },
        {
            title: '이행진단',
            dataIndex: 'implement',
            key: 'implement',
            width: '70px',
            align: 'center',
            render: (_ , rowData ) => {
                return (
                    <Typography.Link onClick={() => onClickDetailHandler({columnType: 'implement', report_id: rowData.report_id})}>
                        { rowData.updated_ymd && rowData.updated_ymd!='None' && (rowData.created_ymd <= rowData.updated_ymd) ?'Report':''}
                    </Typography.Link>
                );
            },
        },
        {
            title: '이행결과',
            dataIndex: 'implementResult',
            key: 'implementResult',
            width: '70px',
            align: 'center',
            render: (_ , rowData ) => {
                return (
                    <Typography.Link onClick={() => onClickDetailHandler({columnType: 'implementResult', report_id: rowData.report_id})}>
                        { rowData.updated_ymd && rowData.updated_ymd!='None' && (rowData.created_ymd <= rowData.updated_ymd) ?'Report':''}
                    </Typography.Link>
                );
            },
        },
    ];

    /** -------------------------------------------------------------------------- **/
    return (
        <>
            <TopMenu selectKey='analysis' />
            <div className="section" onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    onClickSearchHandler();
                }
            }}>
                <table className='search'>
                    <colgroup>
                        <col style={{width:'7%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'7%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'7%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'7%'}} />
                        <col style={{width:'18%'}} />
                    </colgroup>
                    <tbody>
                    <tr>
                        <th><span className='req'>*</span>회사</th>
                        <td>
                            <CodeSelect codeType="com_cd" 
                                        id="companyCode"
                                        value={companyCode}
                                        disabled={authenticated?true:false}
                                        onChangeHandler={onChangeCompanyCode}
                            />
                        </td>
                        <th>자산구분</th>
                        <td>
                            <CodeSelect codeType="asset_type"
                                        id="assetType"
                                        value={assetType}
                                        disabled={false}
                                        onChangeHandler={onChangeAssetType}
                                        showCompanyIndicator={true}
                                        selectedCompanyCode={companyCode}
                            />
                        </td>
                        <th>최초분석일자</th>
                        <td>
                            <RangePicker id="createYmd" size="small" 
                                onChange={onChangeDateRange}
                            />
                        </td>
                        <th>취약점 분석명</th>
                        <td>
                            <Input id="reportName" size="small"
                                   allowClear
                                   value={reportName}
                                   onChange={onChangeInputHandler}
                                   onPressEnter={onClickSearchHandler}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div className="search_button">
                    <Button type="default" onClick={onClickSearchHandler}>조회</Button>
                    <Button type="primary" onClick={onClickCreateHandler}>취약점분석 등록</Button>
                </div>
            </div>
            <div className="section">
                <table style={{width:'100%'}}><tbody>
                  <tr>
                    <td><div style={{marginLeft:'20px'}}>총 {dataSource?.length} 개</div></td>
                    <td style={{textAlign:'right'}}>
                        <Button type="default" onClick={()=> excelDownload('취약점분석 목록', dataSource)}> Excel Download</Button>
                    </td>
                  </tr></tbody>
                </table>
                <Table columns={analysisColumnData}
                       dataSource={dataSource}
                       rowKey="report_id"
                       scroll={{y: getGridTableHeight(290)}}
                       loading={{
                           size: "large",
                           spinning: isLoading
                         }}
                       pagination={false}
                       bordered size={"small"}
                       style={{height:getGridTableHeight(260)}}
                       showSorterTooltip={false}
                />
            </div>
            {isOpenCreate && (<AnalysisCreate
                open={isOpenCreate}
                p_companyCode={companyCode}
                p_companyName={companyName}
                p_assetType={assetType}
                p_assetTypeName={assetTypeName}
                p_assetSpec={assetSpec}
                p_assetSpecName={assetSpecName}
                rowKey="report_id"
                onClose={(p_isChange) => {
                    setIsOpenCreate(false);
                    setIsDataChange(p_isChange);
                }}
            />)}
            {isOpenInfo && (<AnalysisInfo
                open={isOpenInfo}
                p_reportId={isReportId}
                rowKey="report_id"
                onClose={(p_isChange) => {
                    setIsOpenInfo(false);
                    setIsDataChange(p_isChange);
                }}
            />)}
            {isOpenResult && (<AnalysisResult
                open={isOpenResult}
                p_reportId={isReportId}
                p_resultType={isResultType}
                rowKey="report_id"
                onClose={(p_isChange) => {
                    setIsOpenResult(false);
                    setIsDataChange(p_isChange);
                }}
            />)}
        </>
    );
}
export default AnalysisList;